module.exports = __webpack_public_path__ + "img/bottom_01.2e4570b.png";